import { useSelector } from './redux';
import { Core } from '../../store/selectors';

export function useFeatureFlag(flagName: string): boolean {
    const flags = useSelector(Core.featureFlags);
    return flags[flagName] ?? false;
}
